import { forwardRef, memo, useCallback, useRef, useState } from 'react';
import { useFieldRef } from '../../_core/hooks/use-field-ref';
import { DistributiveOmit } from 'types';
import { InputProps } from '../input.types';
import { BLUR_MS, SwappingInput, ToggleButton } from './password-input.styled';

import { EyeToggleIcon } from './eye-toggle-icon';

export const PasswordInput = memo(
  forwardRef<HTMLInputElement, DistributiveOmit<InputProps, 'type' | 'suffix'>>(
    (props, ref) => {
      const [visible, setVisible] = useState<boolean>(false);
      const [swapping, setSwapping] = useState<boolean>(false);
      const timerRef = useRef<number>();

      const { elementRef, attachRef } = useFieldRef<HTMLInputElement>(ref);

      const toggle = useCallback(() => {
        // В пустом поле расфокусировать нечего — переключаем сразу
        if (!elementRef.current?.value) {
          setVisible((current) => !current);

          return;
        }

        // Повторный клик до конца перехода перезапускает его, а не копит таймеры
        window.clearTimeout(timerRef.current);
        setSwapping(true);

        timerRef.current = window.setTimeout(() => {
          setVisible((current) => !current);
          setSwapping(false);
        }, BLUR_MS);
      }, [elementRef]);

      return (
        <SwappingInput
          ref={attachRef}
          $swapping={swapping}
          type={visible ? 'text' : 'password'}
          autoComplete="new-password"
          suffix={
            <ToggleButton
              type="button"
              disabled={props.disabled}
              onClick={toggle}
              aria-label={visible ? 'Скрыть пароль' : 'Показать пароль'}
            >
              <EyeToggleIcon crossed={visible} />
            </ToggleButton>
          }
          {...props}
        />
      );
    }
  )
);

PasswordInput.displayName = 'PasswordInput';
